// eslint-disable-next-line no-restricted-imports
import { Stack, Text, Tooltip, createStyles } from '@mantine/core';
import Image from 'next/image';
import { useState } from 'react';

import silhouette from '~/components/assets/Silhouette.png';
import dt from '~/testing';

function getShortName(name: string) {
  const tokens = name.split(' ');
  if (tokens.length > 1) {
    return `${tokens[0][0]}. ${tokens.slice(1).join(' ')}`;
  }
  return name;
}

const useStyles = createStyles((theme) => ({
  wrapper: {
    borderRadius: theme.radius.md,
    overflow: 'hidden',
  },
  image: {
    objectFit: 'contain',
  },
}));

type EntryItemProps = {
  image?: string;
  name: string;
};

function EntryItem({ image, name }: EntryItemProps) {
  const { classes } = useStyles();
  const [isError, setIsError] = useState(false);

  return (
    <Stack
      bg="gray.0"
      w={72}
      h={72}
      align="center"
      justify="center"
      spacing={0}
      className={classes.wrapper}
      data-test-id={dt.contestDetail.section.myEntries.item.container}
    >
      {image ? (
        <>
          <Image
            width={72}
            height={72 - 21}
            src={isError ? silhouette : image}
            alt={`A photo of ${name}`}
            className={classes.image}
            onError={() => setIsError(true)}
            data-test-id={dt.contestDetail.section.myEntries.item.image}
          />
          <Tooltip label={name} position="bottom" withinPortal>
            <Text
              component="div"
              w={72}
              h={21}
              align="center"
              bg="gray.2"
              fw={700}
              size={14}
              truncate
              /* eslint-disable-line local-rules/use-theme-tokens */ px={3}
              data-test-id={dt.contestDetail.section.myEntries.item.text}
            >
              {getShortName(name)}
            </Text>
          </Tooltip>
        </>
      ) : (
        <Text
          fw={700}
          size={14}
          truncate
          /* eslint-disable-line local-rules/use-theme-tokens */ p={3}
          color="dark"
          data-test-id={dt.contestDetail.section.myEntries.item.text}
        >
          {name}
        </Text>
      )}
    </Stack>
  );
}

export default EntryItem;
